// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var ResetPasswordRoute = function ResetPasswordRoute() {
  return {
    path: 'reset-password',
    getComponent: function getComponent(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('./Root').Root);
      }, 'ResetPassword');
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('./EmailForm').EmailForm
        });
      }, 'ResetPassword');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'welcome/:resetToken',
          component: require('./NewUserPasswordForm.js').NewUserPasswordForm
        }, {
          path: ':resetToken',
          component: require('./PasswordForm').PasswordForm
        }]);
      }, 'ResetPassword');
    }
  };
};